export class CustomParamsPersonnelListingModel {
  StateId: string;
  OrganizationTypeId: string;
  OrganizationID: string;
}
